<template>
  <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{$t('Create An Account')}}</h2>
            <!-- <span class="ipn-subtitle">Register On Resido Today</span> -->
          </div>
        </div>
      </div>
    </div>

    <section class="gray-simple">
      <div class="container">

        <div class="mb-4 d-flex justify-content-center gap-3">
          <button 
            :class="['btn', selectedRole === 'user' ? 'btn-primary' : 'btn-outline-primary']" 
            @click="selectedRole = 'user'">
            {{ $t('User') }}
          </button>
          <button 
            :class="['btn', selectedRole === 'supplier' ? 'btn-primary' : 'btn-outline-primary']" 
            @click="selectedRole = 'supplier'">
            {{ $t('Supplier') }}
          </button>
        </div>

        <div class="row justify-content-center">
          <div class="col-xl-7 col-lg-8 col-md-9">
            <div class="card border-0 rounded-4 p-xl-4 p-lg-4 p-md-4 p-3">
              <div class="simple-form">

                <div class="form-header text-center mb-5">
                  <div class="effco-logo mb-2">
                    <router-link class="d-flex align-items-center justify-content-center" to="/">
                    </router-link>
                  </div>
                  <h4 class="fs-2">{{$t('Create An Account')}}</h4>
                </div>
                <!-- User form -->
                <UserForm v-if="selectedRole === 'user'" :states="states" :categories="categories" />
                <!-- Supplier form -->
                <SupplierForm v-else :states="states" :categories="categories" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />

    <FooterDark />

    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref,watch } from 'vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import SupplierForm from '@/components/supplier-form.vue'
import UserForm from '@/components/user-form.vue'
import {useI18n} from "vue-i18n";
import axios from "axios";
const selectedRole = ref('user')
const { locale } = useI18n();
const states = ref([]);
const categories = ref([]);
const loading = ref(false);
const fetchStates = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-states`,{
      headers:{
        locale:locale.value
      }
    });
    const fetchedStates = response.data.states || [];
    states.value = fetchedStates.map(state => ({
      label: state.name,
      value: state.id
    }));
  } catch (error) {
    console.error("Error fetching states:", error);
  } finally {
    loading.value = false;
  }
};
const fetchCategories = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-categories`,{
      headers:{
        locale:locale.value
      }
    });
    const fetchedCategories = response.data.categories || [];
    categories.value = fetchedCategories.map(category => ({
      label: category.name,
      value: category.id
    }));
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    loading.value = false;
  }
};
watch(locale, fetchStates, { immediate: true });
watch(locale, fetchCategories, { immediate: true });
</script>
